import { reactive } from 'vue'
import { todayYmd, addYearsYmd } from '@/components/Onboarding/onboardingFormat'

let keySeq = 0
export const nextKey = () => `k${++keySeq}`

export const newPlotRow = () => ({ key: nextKey(), name: '', areaM2: '', zone: '', customZone: '', saved: false, id: null })
export const newTeamRow = () => ({ key: nextKey(), name: '', email: '', role: 'OPERATIONS', status: '', error: '' })

function initialState() {
  const start = todayYmd()
  return {
    parkId: '',
    userName: '',
    loaded: false,
    busy: false,
    error: '',
    park: { name: '', rfc: '', contactEmail: '', address: '', city: '', state: '', logoFile: null, logoPreview: '', logoUrl: '', bankName: '', bankBeneficiary: '', bankClabe: '' },
    plots: [newPlotRow()],
    tenant: { name: '', rfc: '', contactName: '', contactEmail: '', plotId: '' },
    contract: { rent: '', startDate: start, endDate: addYearsYmd(start, 1), escalate: false, escalationPercent: 5, openingBalance: '' },
    contractCreated: null, // { id, tenantName, plotName, rent }
    contractsImported: 0, // contratos cargados en bloque desde Excel durante el asistente
    billing: { rentDueDay: 5, serviceDueDays: 15, maintenanceDueDays: 15, manualChargeDueDaysDefault: 15, startMode: 'ZERO', historyFrom: '', historyAssumedPaid: true },
    team: [newTeamRow()],
  }
}

// Estado del asistente compartido por todos los pasos (singleton). Se reinicia al entrar a la vista.
export const ob = reactive(initialState())

export function resetOnboarding() {
  Object.assign(ob, initialState())
}

export const savedPlots = () => ob.plots.filter((p) => p.saved)